import { hideSegundoModal, showSegundoModal } from "_+_Portal/context/Actions/segundoModal/segundoModal";
import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../global/context/Provider";
import { showToaster } from "../../../../global/context/action/toaster/toaster.js";
import isDniValido from "../../../../global/utils/checkDniValido";
import { hideModal, showModal } from "../../../context/Actions/modal/modal";
import { logoutVerificaDni } from "../../../context/Actions/verificaDni/logoutVerificaDni";
import { verificaDni } from "../../../context/Actions/verificaDni/verificaDni";
import { PortalContext } from "../../../context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";
import Mensaje from "../../Genericos/Mensaje/Mensaje";
import "./VincularLogin.css";

const VincularLogin = ({
  dissmiss,
  titulo,
  danger,
  textoNegrita,
  texto,
  tokenRedSocial,
  idRedSocial,
  redSocial,
}) => {
  const {
    modalDispatch,
    verificaDniDispatch,
    verificaDniState,
    segundoModalDispatch, 
  } = useContext(PortalContext);

    // Toaster Global
    const { toasterDispatch } = useContext(GlobalContext);

  const [asociaDni, SetAsociaDni] = useState("");
  const [dniError, setDniError] = useState(false);

  const preventEletter = (e) => {
    if (
      e.key === "e" ||
      e.key === "E" ||
      e.key === "+" ||
      e.key === "." ||
      e.key === "," ||
      e.key === "-"
    ) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      if (isDniValido(e)) {
        verificaDni(asociaDni)(verificaDniDispatch);
      }
    }
    if (e.target.name === "txtAsociaPwd") {
      if (e.key === "Enter") {
        showModalPassword();
      }
    }
  };

  const onChangeAsociaDni = (e) => {
    setDniError(!isDniValido(e));
    SetAsociaDni(e.target.value);
    if (isDniValido(e)) {
      SetAsociaDni(e.target.value);
    }
  };
  const segundoDissmiss = () =>{
    hideSegundoModal()(segundoModalDispatch);
  }

  // const onChangeAsociaPwd = (e) => {
  //   setPwdError(!isPwdValido(e));
  //   SetAsociaPwd(e.target.value);
  //   if (isPwdValido(e)) {
  //     SetAsociaPwd(e.target.value);
  //   }
  // };

  const showModalPassword = () => {
    if (asociaDni !== "") {
      if (dniError) {
        showToaster(
          {
            texto: "Complete el campo correctamente",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      } else {
        verificaDni(asociaDni)(verificaDniDispatch);
      }
    } else {
      showToaster(
        {
          texto: "Complete el campo correctamente",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    document.getElementsByName("txtAsociaDni")[0].focus();
  }, []);

  useEffect(() => {
    if (
      verificaDniState.verificaDni.error !== null &&
      verificaDniState.verificaDni.error !== false
    ) {
      dissmiss(); 
      
      // deberiamos enviar a crear una cuenta 
      showSegundoModal(
        "Auth/Registracion/Registracion",
        {
          dissmiss: segundoDissmiss,
        },
        null,
        "centroDerecha",
        true
      )(segundoModalDispatch);
    
      showToaster(
        {
          texto: "Su Dni no existe en nuestra Base de Datos",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
      logoutVerificaDni()(verificaDniDispatch);
    }
    if (
      verificaDniState.verificaDni.data !== null &&
      verificaDniState.verificaDni.data !== undefined
    ) {
      hideModal()(modalDispatch);
      /*showToaster(
        {
          texto: "Dni verificado!",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      */
      logoutVerificaDni()(verificaDniDispatch);
      setTimeout(() => {
        showModal(
          "Auth/ConfirmarPassword/ConfirmarPassword",
          {
            titulo: "Confirmar Contraseña",
            dissmiss: dissmiss,
            dni: asociaDni,
            tokenRedSocial: tokenRedSocial,
            idRedSocial: idRedSocial,
            redSocial: redSocial
          },
          "centro"
        )(modalDispatch);
      }, 250);
    }
  }, [
    verificaDniState.verificaDni.error,
    verificaDniDispatch,
    verificaDniState.verificaDni.data,
    modalDispatch,
    toasterDispatch,
    dissmiss,
    asociaDni,
  ]);

  return (
    <>
      <div className="ptur-vinculalogin-ingreso-dni">
        <Mensaje titulo={titulo} dissmiss={dissmiss} danger={danger} />
        <div className="ptur-vinculalogin-texto">
          <h5 className="rb18m">{textoNegrita}</h5>
          <span className="rb16t">{texto}</span>
        </div>
        <div className="ptur-vinculalogin-ingreso-dni-input">
          <React.Fragment>
            <InputV1
              inputType="number"
              name="txtAsociaDni"
              headerStr="Ingresa tu Número de documento"
              placeholderText="12345678"
              errorStr="El número de documento no es válido."
              onChange={onChangeAsociaDni}
              onKeyPress={preventEletter}
              value={asociaDni}
              className="inputNonScroll rb16m"
              maxLength="9"
              checkError={dniError}
              isRequired={true}
            />
          </React.Fragment>
        </div>
        <div className="ptur-vinculaLogin-box-btn">
          <button
            className="ptur-vinculaLogin-btnCrear b-latex30 rb18m c-latex30"
            onClick={dissmiss}
          >
            Volver al login
          </button>
          <button
            className="ptur-vinculaLogin-btnIngresar rb18m bgc-primary c-white"
            onClick={showModalPassword}
          >
            Verificar DNI
          </button>
        </div>
      </div>
    </>
  );
};

export default VincularLogin;
